import TagManager from "react-gtm-module";
import React from "react";
import useStyles from "./styles";
import {Button, Snackbar, SnackbarContent} from "@material-ui/core";
import {getCookieQuestionAsked, setCookieAcceptance, setCookieQuestionAsked} from "../../datamanagement/network";
import Box from "@material-ui/core/Box";
import {connect} from "react-redux";

export function CookieSnackbar(props) {
    const classes = useStyles();

    const tagManagerArgs = {
        gtmId: 'GTM-KB4MSMK',
        events: {
            sendUserInfo: 'userInfo'
        }
    }

    const acceptCookies = () => {
        TagManager.initialize(tagManagerArgs)
        setCookieAcceptance()
        setCookieQuestionAsked()
        setOpenCookiesSnackbar(false)

    }
    const [openCookiesSnackbar, setOpenCookiesSnackbar] = React.useState(!getCookieQuestionAsked());

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setCookieQuestionAsked()
        setOpenCookiesSnackbar(false);
    };

    return (
        <div>
            <Snackbar open={openCookiesSnackbar} onClose={handleClose} display={!!getCookieQuestionAsked() ? 'hidden' : ''}>
                <SnackbarContent
                    message="Wir verwenden Cookies, um Ihnen eine bessere Nutzererfahrung zu ermöglichen. Durch die Nutzung
                        unserer Webseite stimmen Sie unserer Verwendung von Cookies zu."
                    action={
                        <Box>
                            <Button variant="contained" color="primary" size="small" className={classes.snackbarButtons} onClick={handleClose}>
                                Ablehnen
                            </Button>
                            <Button variant="contained" color="secondary" size="small" className={classes.snackbarButtons} onClick={acceptCookies}>
                                Zustimmen
                            </Button>
                        </Box>

                    }
                />
            </Snackbar>
        </div>
    );
}

const mapStateToProps = ({user}) => {
    return {user};
}
//
//
// const mapDispatchToProps = dispatch => {
//     return {
//         cookiesAccepted: (openCookiesSnackbar) => cookiesAccepted(dispatch, openCookiesSnackbar),
//     };
// }
//
export default connect(mapStateToProps)(CookieSnackbar);